__turbopack_context__.v({
  "circle": "sUpgQW_circle",
  "loading": "sUpgQW_loading",
  "shadow": "sUpgQW_shadow",
  "wrapper": "sUpgQW_wrapper",
});
